import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltVideoEditorPlayerZoomButtonTriggerWireframe from './VeltVideoEditorPlayerZoomButtonTriggerWireframe/VeltVideoEditorPlayerZoomButtonTriggerWireframe';
import VeltVideoEditorPlayerZoomButtonOptionsWireframe from './VeltVideoEditorPlayerZoomButtonOptionsWireframe/VeltVideoEditorPlayerZoomButtonOptionsWireframe';
var VeltVideoEditorPlayerZoomButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-zoom-button-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerZoomButtonWireframe.Trigger = VeltVideoEditorPlayerZoomButtonTriggerWireframe;
VeltVideoEditorPlayerZoomButtonWireframe.Options = VeltVideoEditorPlayerZoomButtonOptionsWireframe;
export default VeltVideoEditorPlayerZoomButtonWireframe;
